/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {createSelector} from 'reselect';
import {createDeepEqualSelector} from '@ion/applications/src/store/selectors/SelectorUtils';
import {TopSheet} from '../../types/pages';
import {SearchReducerState} from '../types';

// input selectors ...
const selectIsInitialized = ({search: {isInitialized}}) => isInitialized;
const selectLoading = ({search: {loading}}) => loading;
const selectAssets = ({search: {assets}}) => assets;
const selectDrivers = ({search: {drivers}}) => drivers;
const selectGeofences = ({search: {geofences}}) => geofences;
const selectSearchTerm = ({search: {searchTerm}}) => searchTerm;
const selectTopSheet = ({search: {topSheet}}: SearchReducerState) => topSheet;

// output selectors ...
export const isSearchInitializedSelector = createSelector(selectIsInitialized,
  (isInitialized: boolean): boolean => isInitialized
);

export const loadingSearchSelector = createSelector(selectLoading,
  (loading) => loading
);

export const assetsSearchSelector = createDeepEqualSelector(selectAssets,
  (assets) => assets
);

export const driversSearchSelector = createDeepEqualSelector(selectDrivers,
  (loading) => loading
);

export const geofencesSearchSelector = createDeepEqualSelector(selectGeofences,
  (geofences) => geofences
);

export const searchTermSearchSelector = createSelector(selectSearchTerm,
  (searchTerm) => searchTerm
);

export const desktopTopSheetOpenSelector = createDeepEqualSelector(selectTopSheet,
  (topSheet: TopSheet): boolean => topSheet.desktopTopSheetOpen
);

export const activeTopSheetSelector = createDeepEqualSelector(selectTopSheet,
  (topSheet: TopSheet): string => topSheet.activeTopSheet
);

export const mobileTopSheetOpenSelector = createDeepEqualSelector(selectTopSheet,
  (topSheet: TopSheet): boolean => topSheet.mobileTopSheetOpen
);
